/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Tag } from '@blend/enterprise-components';
import { BlendBridge } from 'blb-types/blendBridge';

export const TAG_STATE = {
  awaiting: {
    copy: 'AWAITING RESPONSE',
    theme: 'warning' as Tag.Theme,
  },
  new: {
    copy: 'NEW MESSAGE',
    theme: 'info' as Tag.Theme,
  },
};

export const ENTITY_NAMES: { [key in BlendBridge.API.EntityType]: string } = {
  BLEND_TITLE_AGENCY: 'Settlement Agent',
  LOAN_OFFICER: 'Loan Team',
};

export const BRIDGE_ENTITY_NAME = 'BLEND_TITLE_AGENCY' as BlendBridge.API.EntityType;
